import { SORT_DIRECTION } from '@/shared/constants/sort/sortDirection'
import { SORT_ORDER } from '@/shared/constants/sort/sortOrder'

const DEFAULT_STATE = {
  id: null,
  loading: false,
  actionLoading: false,
  reInviteLoading: false,
  exampleLoading: false,
  formData: {
    approved_count: null,
    approved_sum: null,
    in_emcd_sum: null,
    description: null,
    invited_count: null,
    in_emcd_count: null,
    name: null,
    paid_count: null,
    paid_sum: null,
    pays_error_count: null,
    raw_error_count: null,
    id: null,
    fee_sum: null,
  },

  formDataPaymentInfo: {
    amount: null,
    body: null,
    coin: null,
    fee: null,
  },

  selected: [],

  search: null,

  filters: {
    contractor_statuses: [],
    payment_statuses: [],
  },

  sorting: {
    sort_by: SORT_ORDER.CONTRACTOR_STATUS,
    sort_direction: SORT_DIRECTION.DESC,
  },

  successFileLoaded: false,

  uploadErrors: null,

  items: [],
  page: 1,
  limit: 10,
  total: 0,
  totalAll: 0,
}

export default {
  ...DEFAULT_STATE,
}
